import React, { useEffect, useState } from "react";
import { Select } from "antd";
import bankData from "@constant/bank.json";

type Props = {
  bankCode: string;
  value?: string;
  onChange?: (value: string) => void;
  disabled?: boolean;
};

const BankBranchList = (props: Props) => {
  const { value, onChange, bankCode, disabled } = props;
  const [bankBranchList, setBankBranchList] = useState<{ bankBranchName: string; branchCode: string }[]>();

  const bankBranchOptions = bankBranchList?.map((info: { branchCode: string; bankBranchName: string }) => ({
    value: info.bankBranchName,
    label: info.bankBranchName,
  }));

  useEffect(() => {
    const banches = bankData
      .filter((item) => item.bankCode === bankCode)
      .map((item) => ({
        bankBranchName: item.bankName,
        branchCode: item.branchCode,
      }));
    setBankBranchList(banches);
  }, [bankCode]);

  return (
    <Select
      value={value || undefined}
      showSearch
      onChange={(inputValue) => onChange?.(inputValue)}
      style={{ width: "100%" }}
      filterOption={(input, option: any) => option?.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0}
      placeholder="請選擇"
      options={bankBranchOptions}
      disabled={disabled}
    />
  );
};

export default BankBranchList;
